import { render, staticRenderFns } from "./createStore_user.vue?vue&type=template&id=3cf3ffd8&scoped=true"
import script from "./createStore_user.vue?vue&type=script&lang=js"
export * from "./createStore_user.vue?vue&type=script&lang=js"
import style0 from "./createStore_user.vue?vue&type=style&index=0&id=3cf3ffd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3ffd8",
  null
  
)

export default component.exports